import { useAppSelector } from 'hooks/useAppDispatchSelector';
import { sideModalEnum } from 'helpers/utils';
import AddUser from './add-user';
import AddOrganization from './add-organization';
import AddEditAdministratorRoles from './add-edit-administrator-roles';
import AddEditCompany from './add-edit-company';
import AddEditWorkshopAppointment from './add-edit-workshop-appointment';
import WorkshopAppointmentRequest from './workshop-appointment-request';
import { memo } from 'react';
import AddEditVehicle from './add-edit-vehicle';
import DmsIntegration from './dms-integartion';
import SurveyFeedbackDetails from './survey-feedback-details';
import AddEditOffersTips from './add-edit-offers-tips';

const SideModal = () => {
  const { sideModal } = useAppSelector(state => state.modal);
  const { type } = sideModal;

  const setPopComponent = () => {
    switch (type) {
      case sideModalEnum.ADD_USER:
        return <AddUser />;
      case sideModalEnum.ADD_ORG:
        return <AddOrganization />;
      case sideModalEnum.ADD_EDIT_ADMINISTRATOR_ROLE:
        return <AddEditAdministratorRoles />;
      case sideModalEnum.ADD_EDIT_VEHICLE:
        return <AddEditVehicle />;
      case sideModalEnum.ADD_EDIT_COMPANY:
        return <AddEditCompany />;
      case sideModalEnum.ADD_EDIT_WORKSHOP_APPOINTMENT:
        return <AddEditWorkshopAppointment />;
      case sideModalEnum.WORKSHOP_APPOINTMENT_REQUEST:
        return <WorkshopAppointmentRequest />;
      case sideModalEnum.DMS_INTEGRATION:
        return <DmsIntegration />;
      case sideModalEnum.SURVEY_FEEDBACK_DETAILS:
        return <SurveyFeedbackDetails />;
      case sideModalEnum.ADD_EDIT_OFFERS_AND_TIPS:
        return <AddEditOffersTips />;
      default:
        return <></>;
    }
  };
  return type ? (
    <>
      <div className="modal-backdrop fixed top-0 left-0 right-0 bottom-0"></div>
      {/*Main modal*/}
      <div
        id="common-modal"
        aria-hidden="true"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
        className="modal fixed top-0 left-0 right-0 z-50 w-full overflow-x-hidden overflow-y-auto h-full"
      >
        <div className="modal-dialog relative w-full my-4 flex mx-auto max-w-4xl max-h-[calc(100%-3.5rem)] ">
          {/*Modal content*/}
          <div className="modal-content relative w-full flex flex-col rounded-2xl overflow-hidden max-h-full">
            {/*Modal body*/}
            <div className="modal-body bg-white overflow-hidden">{setPopComponent()}</div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <></>
  );
};

export default memo(SideModal);
